export const RESET = 'CURRENCY_LIST_RESET'
export const SET_ITEMS = 'CURRENCY_LIST_SET_ITEMS'
export const SET_ERROR = 'CURRENCY_LIST_SET_ERROR'
export const SET_VIEW = 'CURRENCY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CURRENCY_LIST_TOGGLE_LOADING'
